// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__wCWwk","gfeWrapper":"CalendarEvent_gfeWrapper__VT_z_"};